import { render, staticRenderFns } from "./WorkspaceAssistantActionProgressOverlay.vue?vue&type=template&id=648364fe&scoped=true"
import script from "./WorkspaceAssistantActionProgressOverlay.vue?vue&type=script&lang=js"
export * from "./WorkspaceAssistantActionProgressOverlay.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceAssistantActionProgressOverlay.vue?vue&type=style&index=0&id=648364fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648364fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648364fe')) {
      api.createRecord('648364fe', component.options)
    } else {
      api.reload('648364fe', component.options)
    }
    module.hot.accept("./WorkspaceAssistantActionProgressOverlay.vue?vue&type=template&id=648364fe&scoped=true", function () {
      api.rerender('648364fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceAssistantActionProgressOverlay.vue"
export default component.exports